import { useEffect, useState } from "react";
import { Box, Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 6,
};

const ModalPopup = ({ title, subtitle, open, setOpen, icon, path, type = "navigate" }) => {
  const navigate = useNavigate();
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        handleClose();
        if (path) {
          if (type === "window-location") {
            window.location.href = path;
          } else {
            navigate(path);
          }
        }
      }, 3000);
    }
  }, [open]);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            width: isMobileView ? "90%" : "30%",
            overflowY: "auto",
            overflowX: "wrap",
            maxHeight: "85vh",
            padding: 0,
          }}
          className="text-left text-base"
        >
          <div className="flex p-4 flex-col items-center">
            <div className="flex flex-col justify-center gap-2 items-center">
              <div className="mt-2">{icon}</div>
              <p className="font-medium text-lg">{title}</p>
            </div>
            <p className="text-slate-500 mb-4 text-wrap py-4 text-center">
              {subtitle}
            </p>
            <button
              className="bg-secondary text-white w-full tracking-wide font-semibold p-3 rounded-lg focus:outline-none focus:shadow-outline hover:bg-secondaryHover shadow-lg transform duration-200 hover:scale-100 disabled:bg-slate-400 disabled:cursor-default"
              type="submit"
              onClick={() => {
                handleClose();
                if (path) navigate(path);
              }}
            >
              Ok
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ModalPopup;
